import React, { useReducer, useEffect, useContext } from "react";
import moduleConfig from "./moduleConfig";
import { Card, Row, Col } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";

import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import axios from "../../../config/axios";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../config/toastNotification";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import FormErrorMessage from "../../UI/errorMessages/FormErrorMessage";

import CMSFormInput from "../../UI/forms/CMSFormInput";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";

import CMSFormTextArea from "../../UI/forms/CMSFormTextArea";
import CMSFormSelect from "../../UI/forms/CMSFormSelect";
import CMSFormImageWithCrop from "../../UI/forms/CMSFormImageWithCrop";
import {
  createReducer,
  createInitialState,
} from "../../../reducers/module/createReducer";
import {
  loadDataForCreateItemGeneral,
  onSubmitGeneral,
} from "../../../helpers/ModuleHelperFunctions";
import CMSFormDate from "../../UI/forms/CMSFormDate";
import CMSFormTime from "../../UI/forms/CMSFormTime";

const SpecialMealDiscountCreate = () => {
  const [createState, createDispatch] = useReducer(
    createReducer,
    createInitialState
  );
  const { setBreadcrumb } = useContext(BreadcrumbContext);
  let navigate = useNavigate();

  const loadDataForCreateItem = async () => {
    await loadDataForCreateItemGeneral(
      `${moduleConfig.url}/fetch-data-for-create-item`,
      createDispatch
    );
  };

  useEffect(() => {
    loadDataForCreateItem();
    setBreadcrumb([
      moduleConfig.breadcrumbs.listing,
      moduleConfig.breadcrumbs.create,
    ]);
  }, []);

  var currentDate = new Date();
  var endDate = new Date();
  endDate.setDate(currentDate.getDate() + 5);

  return (
    <DashboardLayout>
      {createState.status === "fetchFailed" ? (
        <BlockErrorMessage error={createState.error} />
      ) : (
        <>
          {createState.status !== "fetching" && (
            <>
              <ModuleHeader
                moduleTitle={`Create ${moduleConfig.singleItemTitle}`}
                moduleUrl={moduleConfig.url}
              ></ModuleHeader>

              <section className="content">
                <Card>
                  <Card.Body>
                    {createState.isLoading && (
                      <div className="overlay position-absolute containerLoading">
                        <i className="fas fa-2x fa-sync-alt fa-spin"></i>
                      </div>
                    )}
                    <Formik
                      initialValues={{
                        title: "",
                        planId: "",
                        requiredKidsCount: 0,
                        discountValue: 0,
                        description: "",
                        status: "0",
                      }}
                      validationSchema={yup.object({
                        title: yup.string().required("Title is required"),

                        planId: yup.string().required("Plan is required"),

                        requiredKidsCount: yup
                          .number()
                          .typeError("Required kids count must be a number")
                          .required("Required kids count is required"),

                        discountValue: yup
                          .number()
                          .typeError("Discount value must be a number")
                          .required("Discount value is required"),

                        description: yup.string().nullable(),

                        status: yup.string().required("Status is required"),
                      })}
                      enableReinitialize={true}
                      validateOnChange={true}
                      validateOnBlur={true}
                      onSubmit={async (values, { resetForm }) => {
                        await onSubmitGeneral(
                          values,
                          moduleConfig.url,
                          moduleConfig.url,
                          createDispatch,
                          navigate
                        );
                      }}
                    >
                      {(form) => (
                        <Form onSubmit={form.handleSubmit}>
                          {createState.error && (
                            <FormErrorMessage error={createState.error} />
                          )}

                          <CMSFormInput
                            name="title"
                            label="Title"
                            required={true}
                            form={form}
                          />

                          <CMSFormSelect
                            name="planId"
                            label="Plan"
                            selectionValue="value"
                            selected={form.values.planId}
                            required={true}
                            form={form}
                            options={
                              createState.data && createState.data.items
                                ? createState.data.items
                                : []
                            }
                            displayValue="label"
                          />

                          <CMSFormInput
                            name="requiredKidsCount"
                            label="Required Kids Count"
                            info={'Discount applies if the user meets the active subscription count and adds a new subscription'}
                            required={true}
                            form={form}
                          />

                          <CMSFormInput
                            name="discountValue"
                            label="Discount Value"
                            info={'Discount will be applied in percentage'}
                            required={true}
                            form={form}
                          />

                          {/* <CMSFormTextArea
                            name="description"
                            label="Description"
                            form={form}
                            maxLength={300}
                          /> */}

                          <CMSFormSelect
                            name="status"
                            label="Status"
                            form={form}
                             required={true}
                            options={[
                              { label: "Select Status...", value: "" },
                              { label: "Enabled", value: "1" },
                              { label: "Disabled", value: "0" },
                            ]}
                          />

                          <button type="submit" className="btn btn-primary ">
                            Submit
                          </button>
                        </Form>
                      )}
                    </Formik>
                  </Card.Body>
                </Card>
              </section>
            </>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default SpecialMealDiscountCreate;
